<template>
  <b-modal
    v-model="shown"
    size="lg"
    header-class="px-5"
    footer-class="px-5"
    body-class="px-5"
    centered no-close-on-esc no-close-on-backdrop>

    <div slot="modal-header">
      <h4 class="py-0">
        Send messages to "{{ name }}" segment
      </h4>
    </div>

    <div class="py-3">
      <b-form-group>
        <b-form-radio-group v-model="channel" name="channel">
          <b-form-radio value="sms">Send via SMS</b-form-radio>
          <b-form-radio value="email">Send via mail</b-form-radio>
        </b-form-radio-group>
      </b-form-group>

      <b-form-group>
        <b-form-textarea
          v-model="message"
          placeholder="Type your message here"
          :rows="3">
        </b-form-textarea>
      </b-form-group>

      <b-alert
        variant="danger"
        dismissible
        :show="showError"
        @dismissed="showError=false">
        The system is not configured to send messages for this user
      </b-alert>
    </div>

    <b-row slot="modal-footer" class="text-right">
      <b-button @click="onClose" :disabled="isSaving" variant="outline" class="px-3 mr-2" size="md">
        Cancel
      </b-button>
      <b-button @click="onSave" :disabled="isSaving || !message" variant="success" class="px-3" size="md">
        <i class="fa fa-spinner fa-spin mr-2" v-if="isSaving"/>
        Send Messages
      </b-button>
    </b-row>
  </b-modal>
</template>

<script>
  export default {
    name: 'PrecisionMarketing',

    props: {
      name: {
        type: String,
        required: true
      },
      count: {
        type: Number,
        default: 0
      }
    },

    data() {
      return {
        shown: true,
        isSaving: false,
        channel: 'sms',
        message: '',
        showError: false
      };
    },

    methods: {
      onClose() {
        this.isSaving = false;
        this.shown = false;
        this.$emit('close');
      },

      onSave() {
        this.isSaving = true;
        setTimeout(() => {
          this.showError = true;
          this.isSaving = false;
        }, 200);
      },
    }
  };
</script>

<style scoped>

</style>
